import React, { FC } from 'react';

import { HStack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { FilterLabelWrapper } from 'components/DataDisplay/Box/BorderedBox/FilterLabelWrapper';
import { useTicketsContext } from 'containers/Findings/Tickets/Components/hooks/context';
import { TicketFilters } from 'containers/Findings/Tickets/Components/TicketFilters';
import { selectTickets } from 'containers/Findings/Tickets/selectors';

export const TicketTableFilters: FC = () => {
  const { tickets, assignees } = useSelector(selectTickets);

  const context = useTicketsContext();

  return (
    <HStack>
      <FilterLabelWrapper>FILTER BY</FilterLabelWrapper>
      <TicketFilters
        {...context}
        isDisabled={tickets.isLoading}
        isLoadingAssignees={assignees.isLoading}
      />
    </HStack>
  );
};
